import React from "react";
import BoxLoader from "../../general/boxLoader";
import EmptyBox from "../../general/emptyBox";
import PendingDeviceCardsBoxItem from "./pendingDeviceCardsBox_item";

const PendingDeviceCardsBox = ({
  dataList,
  dataListTitles,
  isRequesting
}) => {
    const _dataList = dataList?.data && dataList?.data.length > 0 && dataList?.data.map((item, i) => {
      return <PendingDeviceCardsBoxItem item={item} dataListTitles={dataListTitles} key={i} />
    })
  return(
    <div>
      { isRequesting ? <BoxLoader /> : _dataList ? _dataList : <EmptyBox /> }
    </div>
  )
}

export default PendingDeviceCardsBox;